module.exports = __webpack_public_path__ + "static/media/Asset 2.7500addf.png";